import qs from 'qs';

/**
 * @param {Location} location - browser Location object
 * @param {string} param - query param to lookup
 * @returns {string|undefined}
 * Would be nice to use URLSearchParams instead, but not supported on IE and don't see a good polyfill
 */
export const getQueryParam = (location, param) => {
  const queryString = location.search === '' ? location.search : location.search.slice(1);
  return qs.parse(queryString)[param];
};

/**
 * Builds a path with query string support, handling both string and object, i.e. react-router, paths.
 * @param {string|object} path - A URL string or a react-router location object.
 * @param {object} queryParams - Key-value pairs for query parameters.
 * @returns {string|object} - Path with appended query string.
 */
export const buildPathWithQuery = (path, queryParams = {}) => {
  if (!queryParams || Object.keys(queryParams).length === 0) return path;

  const queryString = new URLSearchParams(queryParams).toString();

  if (typeof path === 'object') {
    return {
      ...path,
      search: `?${queryString}`,
    };
  }

  return `${path}?${queryString}`;
};
